import axios from 'axios';

export const patchSwrFetcher = async <T, R>(url: string, { arg }: { arg: T }) => {
  const response = await axios.patch<R>(url, arg);

  return response.data;
};
